import { render, staticRenderFns } from "./CustomerPurchaseOrderDetails.vue?vue&type=template&id=4644905a&lang=pug&"
import script from "./CustomerPurchaseOrderDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerPurchaseOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPurchaseOrderDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports